import { ReservationFlowTicketBookAvailableReservationCount } from '../../../../interfaces/reservation_flow';

// 購入済み回数券が予約回数によって制限されているかの判定
export const isRestrictedTicketBookReservationCount: (
  availableReservationCount: ReservationFlowTicketBookAvailableReservationCount,
) => boolean = (availableReservationCount) => {
  return Object.values(availableReservationCount.value).some((value) => {
    // nullは制限が設定されていない状態
    if (value === null) {
      return false;
    }

    // 制限されている場合は0が設定される
    return value === 0;
  });
};
